module.exports = __webpack_public_path__ + "img/qr_screenshot.abdee9c3.png";